import { DELETE_HOW_TO_APPLY_START } from '../../types';

export const delete_how_to_apply = (payload) => ({
  type: DELETE_HOW_TO_APPLY_START,
  payload,
});
